import { TokenService } from './../services/token.service';
import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService, ToastService } from '../services';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private tokenService: TokenService,
    private authService: AuthService,
    private readonly toastService: ToastService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const token = this.tokenService.getToken();
    // const currsentUser = this.authService.getUser();
    if (token) {
      return true;
    }

    this.toastService.showError('Unauthorized! Token Expired');
    this.authService.logOut();
    this.router.navigate(['/home']);
    return false;
  }
}
